import { useEffect, useState } from 'react'

// The side-by-side grid needs room for a 420px form column plus the job
// info panel — below this (phones and small tablets) the sheet flow is used,
// matching the design mockup's single-column collapse at 980px
export const DESKTOP_MEDIA_QUERY = '(min-width: 980px)'

const matchesDesktop = () =>
  typeof window !== 'undefined' &&
  'matchMedia' in window &&
  window.matchMedia(DESKTOP_MEDIA_QUERY).matches

/**
 * Reads the viewport synchronously on first render so desktop users never
 * see a flash of the mobile Apply bar before the side-by-side layout mounts.
 *
 * Shared by `ShortFormPage` and the public job board, which need the same
 * breakpoint to decide whether a card selects in place or navigates.
 */
export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(matchesDesktop)

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) {
      return undefined
    }
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY)
    const onChange = (event: MediaQueryListEvent) => setIsDesktop(event.matches)
    setIsDesktop(mediaQuery.matches)
    mediaQuery.addEventListener('change', onChange)
    return () => mediaQuery.removeEventListener('change', onChange)
  }, [])

  return isDesktop
}

export default useIsDesktop
